<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">User List</div>
							<!-- Page Header -->
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">You can search for users by User ID, Name, Status, Company, or Department.</div>
									<div class="tips">The following operations are available for user management:</div>
									<div class="tips">· Click "Edit" to modify user information and module permissions.</div>
									<div class="tips">· Click "Reset Password" to change the user's password.</div>
									<div class="tips">· Click "Disable" to deactivate the user account.</div>
									<div class="tips">· Click "Enable" to reactivate the user account.</div>
									<div class="tips">· Click "Delete" to permanently remove the user account. This action cannot be undone.</div>
								</div>

								<!-- Search -->
								<div class="search_box">
									<div class="search_el">
										<div class="search_el_el mr_r">
											<div class="tit">User ID</div>
											<el-input v-model="query.user_id" placeholder="Please enter" clearable></el-input>
										</div>
										<div class="search_el_el mr_l">
											<div class="tit">User Name</div>
											<el-input v-model="query.username" placeholder="Please enter" clearable></el-input>
										</div>
									</div>

									<div class="search_el">
										<!-- <div class="search_el_el mr_r">
											<div class="tit">Company</div>
											<el-select
												v-model="query.company_id"
												placeholder="Please select"
												clearable
												style="width: 100%;"
												@change="getDepartment(query.company_id)"
											>
												<el-option
													v-for="value in companyList"
													:key="value.id"
													:label="value.company_name"
													:value="value.id"
												></el-option>
											</el-select>
										</div> -->
										
										
										<div class="search_el_el mr_r">
											<div class="tit">User Status</div>
											<el-select
												v-model="query.status"
												placeholder="Please select"
												clearable
												style="width: 100%;"
											>
												<el-option label="Enabled" value="1"></el-option>
												<el-option label="Disabled" value="2"></el-option>
											</el-select>
										</div>

										<div class="search_el_el mr_l">
											<div class="tit">Department</div>
											<el-select
												v-model="query.departments_id"
												placeholder="Please select"
												clearable
												style="width: 100%;"
											>
												<el-option
													v-for="value in departmentsList"
													:key="value.id"
													:label="value.departments_name"
													:value="value.id"
												></el-option>
											</el-select>
										</div>
									</div>

									<div class="btn_box">
										<van-button
											class="btn_el"
											round
											color="linear-gradient(to right, #7BC1FF, #4886FF)"
											@click="search"
										>
											Search
										</van-button>
									</div>
								</div>
								<!-- Search -->

								<!-- Table -->
								<div class="table_box">
									<el-table
										v-loading="tableLoading"
										:data="tableData"
										border
										class="table_el"
										ref="multipleTable"
										header-cell-class-name="table-header"
									>
										<el-table-column
											prop="id"
											label="Action"
											width="80"
											align="center"
										>
											<template #default="scope">
												<div class="inline_btn">
													<el-button
														type="primary"
														size="mini"
														@click="handleClick('Edit', scope.row)"
													>
														Edit
													</el-button>
												</div>
											</template>
										</el-table-column>

										<el-table-column
											prop=""
											label="Status"
											width="120"
											align="center"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												<el-tag
													:type="scope.row.status == 1 ? 'success' : scope.row.status == 2 ? 'danger' : ''"
												>
													{{ scope.row.status == 1 ? 'Enabled' : 'Disabled' }}
												</el-tag>
											</template>
										</el-table-column>

										<el-table-column
											prop="user_id"
											label="User ID"
											width="180"
											:show-overflow-tooltip="true"
										></el-table-column>

										<el-table-column
											prop="username"
											label="User Name"
											width="180"
											:show-overflow-tooltip="true"
										></el-table-column>

										<!-- <el-table-column
											prop=""
											label="Company"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												{{ scope.row.company_name || '/' }}
											</template>
										</el-table-column> -->

										<el-table-column
											prop=""
											label="Department"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												{{ scope.row.departments_name || '/' }}
											</template>
										</el-table-column>

										<el-table-column
											prop=""
											label="Email"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												{{ scope.row.email || '/' }}
											</template>
										</el-table-column>

										<el-table-column
											prop="id"
											label="Action"
											width="300"
											align="center"
										>
											<template #default="scope">
												<div class="inline_btn">
													<el-button
														type="primary"
														size="mini"
														@click="handleClick('Reset Password', scope.row)"
													>
														Reset Password
													</el-button>
												</div>

												<div
													v-if="scope.row.status == 1"
													class="inline_btn mr_l"
												>
													<el-button
														type="warning"
														size="mini"
														@click="handleClick('Disable', scope.row)"
													>
														Disable
													</el-button>
												</div>

												<div
													v-if="scope.row.status == 2"
													class="inline_btn mr_l"
												>
													<el-button
														type="primary"
														size="mini"
														@click="handleClick('Enable', scope.row)"
													>
														Enable
													</el-button>
												</div>

												<div class="inline_btn mr_l">
													<el-button
														type="danger"
														size="mini"
														@click="handleClick('Delete', scope.row)"
													>
														Delete
													</el-button>
												</div>
											</template>
										</el-table-column>
									</el-table>

									<div class="pagination">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handlePageChange"
											:current-page="query.page"
											:page-sizes="[5, 10, 20, 50]"
											:page-size="query.page_size"
											layout="total, sizes, prev, pager, next"
											:total="pageTotal"
										>
										</el-pagination>
									</div>
								</div>
								<!-- Table -->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<!-- Reset Password -->
		<el-dialog title="Reset Password" :visible.sync="dialogVisible" width="30%">
			<div class="reset_box">
				<div class="tips_el">
					<div class="tips">Your password must meet the following requirements:</div>
					<div class="tips">At least 6 characters long</div>
					<div class="tips">Contain at least one letter</div>
					<div class="tips">Contain at least one number</div>
				</div>

				<div class="form_box">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
						<div class="input_el">
							<div class="tit required">Password</div>
							<el-form-item label="" prop="pwd">
								<el-input
									v-model="ruleForm.pwd"
									placeholder="Please enter"
									clearable
									show-password
								></el-input>
							</el-form-item>
						</div>

						<div class="input_el">
							<div class="tit required">Confirm Password</div>
							<el-form-item label="" prop="pwd2">
								<el-input
									v-model="ruleForm.pwd2"
									placeholder="Please enter"
									clearable
									show-password
								></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>

				<div class="btn_box">
					<van-button
						class="btn_el"
						type="default"
						round
						@click="dialogVisible = false"
					>
						Cancel
					</van-button>

					<van-button
						class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')"
					>
						Save
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!-- Reset Password -->

		<!-- Loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!-- Loading -->
	</div>
</template>

<script>
import { usersList, usersDel, usersUpdStatus, usersResetpwd } from '@/api/system/user';
// import { companyList } from '@/api/system/company';
import { departmentsList } from '@/api/system/department';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from 'js-md5';
export default {
	components:{
		headers,
		slider
	},
	data() {
		return {
			isLoading: true,
			query: {
				user_id: '',
				username: '',
				// email: '',
				status: '',
				// company_id: '',
				departments_id: '',
				// time: '',
				page: 1,
				page_size: 10
			},
			tableLoading: false,
			tableData: [],
			pageTotal: 0,  //总条数
			dialogVisible: false,
			resetId: null,
			ruleForm: {
				pwd: '',
				pwd2: ''
			},
			rules: {
				pwd: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				pwd2: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				]
			},
			// companyList: [],
			departmentsList: []
		}
	},
	created(){
		let that = this;
		// companyList({ page: 1, page_size: 9999, status: 1, company_name: '', company_userid: '', manage_userid: '' }).then(res => {
		// 	if(res.code == 200) {
		// 		that.companyList = res.data.data;
		// 	}
		// });
		that.departmentsList();
		// departmentsList({ page: 1, page_size: 9999, status: 1, departments_name: '', company_id: '', departments_userid: '' }).then(res => {
		// 	if(res.code == 200) {
		// 		that.departmentsList = res.data.data;
		// 	}
		// });
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getDepartment();
		that.getTableData();
	},
	watch: {
		//
	},
	methods: {
		//获取表格数据
		getTableData() {
			let that = this;
			that.tableLoading = true;
			usersList(that.query).then(res => {
				that.tableLoading = false;
				if(res.code == 200) {
					that.pageTotal = res.data.total;
					that.tableData = res.data.data;
				}else {
					
				}
			});
		},
		//搜索
		search(formName) {
			let that = this;
			that.getTableData();
		},
		//条数选择
		handleSizeChange(value) {
			let that = this;
			that.query.page_size = value;
			that.getTableData();
		},
		//页数跳转
		handlePageChange(value) {
			let that = this;
			that.query.page = value;
			that.getTableData();
		},
		//获取部门
		getDepartment(val) {
			let that = this;
			that.query.departments_id = '';
			that.departmentsList = [];
			that.$toast.loading({ duration: 0, forbidClick: true });
			departmentsList({ page: 1, page_size: 9999, status: 1, departments_name: '', departments_userid: '' }).then(res2 => {
				that.$toast.clear();
				that.departmentsList = res2.data.data;
				if(val) {
					that.query.departments_id = val;
				}
			});
		},
		//重置密码保存
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					//校验密码
					if(that.ruleForm.pwd != that.ruleForm.pwd2) {
						that.$message('Please set a valid password for the user.');
						return false;
					}
					if(!/^(?=.*[A-Za-z])(?=.*\d).{6,}$/.test(that.ruleForm.pwd)) {
						that.$message('Password must be at least 6 characters and contain at least one letter and one number.');
						return false;
					}
					if(that.resetId) {
						that.$toast.loading({ duration: 0, forbidClick: true });
						usersResetpwd({
							id: that.resetId,
							password: md5(that.ruleForm.pwd+'AiisoQms2026')
						}).then(res => {
							if(res.code == 200) {
								that.resetId = null;
								that.ruleForm.pwd = '';
								that.ruleForm.pwd2 = '';
								that.$toast.clear();
								that.$message.success('Operation successful');
								that.dialogVisible = false;
							}else {
								
							}
						});
					}
				}else {
					return false;
				}
			});
		},
		//操作按钮点击
		handleClick(name, value) {
			let that = this;
			switch (name) {
			    case 'Edit':
					that.$router.push({ path: '/system/user/add-edit', query: { oid: value.id } });
				break;
				case 'Disable':
					that.$confirm('Are you sure you want to disable this user?', 'Confirmation', {
						type: 'warning'
					}).then(() => {
						that.$toast.loading({ duration: 0, forbidClick: true });
						usersUpdStatus({ id: value.id, status: 2 }).then(res => {
							that.$toast.clear();
							that.$message.success('Operation successful');
							value.status = 2;
						});
					}).catch(() => {
						// that.$message({ type: 'info', message: '您已取消退出登录' });
					});
				break;
				case 'Enable':
					that.$confirm('Are you sure you want to enable this user?', 'Confirmation', {
						type: 'warning'
					}).then(() => {
						that.$toast.loading({ duration: 0, forbidClick: true });
						usersUpdStatus({ id: value.id, status: 1 }).then(res => {
							that.$toast.clear();
							that.$message.success('Operation successful');
							value.status = 1;
						});
					}).catch(() => {
						// that.$message({ type: 'info', message: '您已取消退出登录' });
					});
				break;
				case 'Delete':
					that.$confirm('Are you sure you want to delete this user?', 'Confirmation', {
						type: 'warning'
					}).then(() => {
						that.$toast.loading({ duration: 0, forbidClick: true });
						usersDel({ id: value.id }).then(res => {
							that.$toast.clear();
							that.$message.success('Operation successful');
							that.getTableData();
						});
					}).catch(() => {
						// that.$message({ type: 'info', message: '您已取消退出登录' });
					});
				break;
				case 'Reset Password':
					that.resetId = value.id;
					that.dialogVisible = true;
				break;
			}
		},
		//取消
		cancel() {
			this.$router.back();
		},
	}
}
</script>

<style lang="less" scoped>
//重置密码
.reset_box{
	.btn_box{
		text-align: right;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
	.tips_el{
		margin: 10px 0 20px 0;
		border-radius: 6px;
		background-color: #ffb1001a;
		padding: 10px 8px;
		.tips{
			padding: 2px 0;
			font-size: 16px;
			font-weight: bold;
		}
	}
	.form_box{
		.input_el{
			.tit{
				padding-bottom: 5px;
				font-size: 14px;
				color: #333333;
			}
			.required::before {
				content: '*';
				color: red;
				margin-right: 2px;
			}
		}
	}
}
//主要内容
.main_main{
	.page_main{
		padding: 18px 20px;
		//表格
		.table_box{
			width: 100%;
			.inline_btn{
				display: inline-block;
			}
			.pagination {
				margin: 10px 0;
				text-align: right;
			}
			.mr_l{
				margin-left: 10px;
			}
		}
		//搜索
		.search_box{
			.search_el{
				display: flex;
				padding-bottom: 10px;
				.search_el_el{
					flex: 1;
				}
				.mr_r{
					margin-right: 10px;
				}
				.mr_l{
					margin-left: 10px;
				}
			}
		}
		.btn_box{
			text-align: right;
			.btn_el{
				margin-left: 10px;
				padding: 12px 24px;
				.van-button__text{
					font-size: 16px;
				}
			}
		}
		.btn_el{
			margin: 10px 0 20px 0;
			border-radius: 6px;
			background-color: #ffb1001a;
			padding: 10px 8px;
			.tips{
				padding: 2px 0;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	//页头
	.page_header{
		padding: 0 20px;
		height: 60px;
		line-height: 60px;
		background-color: #d8e4f0;
		font-size: 24px;
		font-weight: bold;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
	}
}
</style>
<style scoped>
.main_box{
	height: calc(100vh - 60px);
	overflow-y: auto;
}
.main_box .main_main{
	position: relative;
	min-height: calc(100% - 0px);
	max-height: auto;
	background-color: #FAFAFA;
}
.el-header, .el-main{
	padding: 0;
}
::v-deep .table_box .inline_btn .el-button{
	padding: 2px 6px;
}
</style>

